export const CONSENT_CATEGORIES = [
  { dbKey: 'advertising', cookieKey: 'dg-category-marketing' },
  { dbKey: 'analytics', cookieKey: 'dg-category-performance' },
  { dbKey: 'functional', cookieKey: 'dg-category-functional' },
];

export const preferencesToCookieOptions = pref => ({
  isCustomised: true,
  cookieOptions: [
    { 'gtm_key': 'dg-category-essential', isEnabled: true },
    ...CONSENT_CATEGORIES.map(({ dbKey, cookieKey }) => ({
      'gtm_key': cookieKey,
      isEnabled: pref[dbKey],
    })),
  ],
});

export const parseDataGrailCookie = () => {
  const cookieEntry = document.cookie
    .split('; ')
    .find(row => row.startsWith('datagrail_consent_preferences='));
  if (!cookieEntry) return null;

  return Object.fromEntries(
    cookieEntry
      .slice('datagrail_consent_preferences='.length)
      .split('|')
      .map(pair => {
        const [key, value] = pair.split(':');
        return [key, value === '1'];
      })
  );
};

export const isWebsiteEditor = (url = '/') => {
  const { pathname, searchParams } = new URL(url, window.location.origin);
  return pathname === '/' && searchParams.has('edit');
};

export const shouldShowBanner = (isFastboot, url, cookies) => {
  if (isFastboot || isWebsiteEditor(url)) return false;

  return !cookies.exists('datagrail_consent_preferences');
};
